<template>
    <!-- <modal :name="modalName" transition="fade" top="0" width="370" height="auto" draggable="true"
        @before-open="beforeOpen" :adaptive="true"> -->
    <div class="filter modal-container">
        <div v-for="filterSection in filterConfiguration" :key="filterSection.sectionLabel"
            class="modal-filter-section">
            <div class="modal-filter-section-header">
                <h4>{{ filterSection.sectionLabel }}</h4>
                <button v-if="!hideReset" @click="resetFilterSection(filterSection)">Reset</button>
            </div>
            <div v-for="fieldConfig in filterSection.sectionFields" :key="fieldConfig.displayLabel"
                class="modal-filter-item">
                <label class="filter-label" for="category-select">{{ fieldConfig.displayLabel }}</label>

                <v-select v-if="fieldConfig.configuration.type == 'select'" v-model="formData[fieldConfig.key]"
                    :items="fieldConfig.configuration.options" id="category-select" item-text="label" item-value="value"
                    dense :placeholder="fieldConfig.configuration.placeholder" :clearable="fieldConfig.configuration.clearable ?? true" class="item" />
                <v-text-field v-else-if="fieldConfig.configuration.type == 'input'" v-model="formData[fieldConfig.key]"
                    dense :placeholder="fieldConfig.configuration.placeholder" :clearable="fieldConfig.configuration.clearable ?? true" class="item">
                </v-text-field>
            </div>
        </div>
        <div class="modal-filter-apply-filters">
            <button @click="close()">Apply Filters</button>
        </div>
    </div>
    <!-- </modal> -->

</template>

<script>
import * as Constants from "../../js/constants.js";

const NAME = Constants.SELECT_FILTERS_MODAL

export default {
    name: NAME,
    props: ["updateFiltersCallback", "filterConfiguration", "currentFilters", "hideReset"],
    data() {
        return {
            modalName: NAME,
            formData: {}
        }
    },
    created() {
        this.initializeFormData();
    },
    methods: {
        show() {
            this.$modal.show();
        },
        close() {
            console.log("Select Filters Modal data", JSON.stringify(this.formData, null, 2));
            this.$props.updateFiltersCallback(this.formData);
            this.$emit('close')
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
        },
        resetFilterSection(section) {
            let keys = section.sectionFields.map(item => item.key)
            console.log("Filter Keys", keys)
            keys.forEach(key => {
                this.formData[key] = ""
            })
        },
        initializeFormData() {
            this.formData = { ...this.currentFilters };

            // Ensure every configured field exists so v-model remains reactive.
            this.filterConfiguration.forEach(section => {
                section.sectionFields.forEach(field => {
                    if (!(field.key in this.formData)) {
                        this.$set(this.formData, field.key, "");
                    }
                });
            });
        },
    }
}
</script>

<style scoped>
.modal-container {
    background-color: white;
    color: black
}

.modal-filter-section {
    border-bottom: 1px solid #ECEDF0;
}

.modal-filter-section-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 16px 0px;
    justify-content: space-between;
}

.modal-filter-section-header button {
    color: purple;
    font-size: 14px;
}

.filter-label {
    text-align: left;
    display: block;
    width: 100%;
    font-size: 12px;
    color: gray
}

.modal-filter-item {
    width: 100%;
}

.modal-filter-item .v-select {
    width: 100% !important;
    max-width: none !important;
}

.modal-filter-item input {
    width: 100% !important;
    max-width: none !important;
    border: 0;
    outline: 0;
}

.modal-filter-item .item {
    background-color: gray10;
    border-radius: 4px;
}

.modal-filter-apply-filters {
    width: 100%;
    padding: 8px 0px;
}

.modal-filter-apply-filters button {
    font-family: 'roboto';
    width: 100%;
    background-color: #699991;
    border-radius: 4px;
    padding: 8px 0px;
    color: white;
    font-size: 16px;
}
</style>